import React, { memo } from 'react';
import { Checkbox, FormControlLabel, FormHelperText } from '@material-ui/core';
import { CustomInputType } from '../../../model/global';
import { getPrefixedFieldId } from '../../utils';
import { CustomFormFieldState } from '../CustomFormField/CustomFormField';
import { useSelector } from 'react-redux';
import { translationsSelector } from '../../../store/modules/translations/selectors';
import useStyles from './styles';

interface Props {
	field: CustomFormFieldState;
	onChange: (event: CustomFormFieldState) => void;
	validationError: string;
}
const CheckBox: React.FC<Props> = ({ field, validationError, onChange }): JSX.Element => {
	const classes = useStyles();
	const { formRequiredField } = useSelector(translationsSelector)

	const [validationMessageState, setValidationMessageState] = React.useState('');

	const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, _field: CustomInputType): void => {
		const {
			name,
			value,
			required,
			validity: { valid },
			checked,
		} = event.target;

		if (valid) {
			setValidationMessageState('');
		} else {
			setValidationMessageState(formRequiredField)
		}

		onChange({
			name,
			value,
			originalField: _field,
			valid,
			invalidReason: formRequiredField,
			checked: checked,
			required,
		});
	};

	/** Support for external field validation messages */
	const getHelperText = (): string => {
		return validationError || validationMessageState || '';
	}

	const controlId = getPrefixedFieldId(field.originalField.id || field.originalField.name);

	return (
		<>
			<FormControlLabel
				className={classes.label}
				control={
					<Checkbox
						checked={!!field.checked}
						className={classes.checkbox}
						onChange={(e) => handleCheckboxChange(e, field.originalField as CustomInputType)}
						name={field.name}
						id={controlId}
						color="primary"
						value={field.value}
						required={field.required}
					/>
				}
				label={
					<div className={classes.labelWrapper} dangerouslySetInnerHTML={{
						__html: field.originalField.title || '',
					}}></div>
				}
			/>
			<FormHelperText className={classes.validationWrapper}>{getHelperText()}</FormHelperText>
		</>
	);
};

export default memo(CheckBox);
